const namespace = "support";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig ={
  name: "Support",
  namespace: "support",
  description: null,
  version: "0.1.0",
  icon: "mdi-school",
  parentRoute: "/support",
  defaultRoute: "overview",
  accentColor: "#FF8200",
  component: () => import( /* webpackChunkName: "tutorials-parent" */ "@/apps/tutorials/Application.vue"),
  childRoutes,
  navigation: [],
  settings: {
    city: "Sugar Land",
    state : "Texas",
    favoriteColor : "blue",
  },
  store : {
    dateFormat : {
      default: "YYYY-MM-DD",
      storageMode : sessionStorage,
    },
    client_id : {
      default: "849a22a8-8b1a-4255-8b2f-8cf8fc19b417",
      storageMode : sessionStorage,
    },
    scope : {
      default: "https://graph.microsoft.com/User.Read",
      storageMode : sessionStorage,
    },
    authorize_url : {
      default: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
      storageMode : sessionStorage,
    },
    token_url : {
      default: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
      storageMode : sessionStorage,
    },
    logout_url : {
      default: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080/",
      storageMode : sessionStorage,
    },
    debug : {
      default: true,
      storageMode : sessionStorage,
    },
  },
}

export default AppConfig.merge(appConfig);
